import React from 'react';
import { Col, Row } from 'tea-component';
import { PostMetrics, CommentsMetrics } from './Metrics';
import ChartItem from './ChartItem';
import './index.scss';
import { useUrlEngagementInfo } from '../../hook';
import {
  keywordDrillUrlAddedCommentTips,
  keywordDrillUrlViewsTimeTips,
  keywordDrillUrlViewsTips,
} from '@op/components/BubbleCommon';
import { DBO_TM } from '@op/utils/format';

export default function UrlMetricsCard(props: {
  filter: any;
  gameInfo: any;
  isSingleUrl?: boolean;
  setApiLoading?: (key: string) => void;
}) {
  const { loading, isEmpty, postEngagement, commentsEngagement } =
    useUrlEngagementInfo({
      filter: props.filter,
      setApiLoading: props.setApiLoading,
    });
  const nearValue = `(${DBO_TM.timeTitle({
    ...props.filter,
    date_type: 'daily',
  })})`;

  return (
    <Row className="dbo-analysis-card-container dbo-analysis-card-container--url">
      <>
        {[
          {
            title: 'Views',
            type: 'views',
            tips: keywordDrillUrlViewsTips,
            timeTips: keywordDrillUrlViewsTimeTips,
          },
          {
            title: 'Added Comment Count',
            type: 'comments',
            tips: keywordDrillUrlAddedCommentTips,
            nearValue: nearValue,
          },
        ].map(({ title, type, tips, nearValue, timeTips }) => {
          return (
            <Col span={8} key={type}>
              <ChartItem
                {...props}
                title={title}
                type={type as any}
                tips={tips}
                nearValue={nearValue}
                timeTips={timeTips}
              ></ChartItem>
            </Col>
          );
        })}
      </>
      <Col span={8}>
        <PostMetrics
          postEngagement={postEngagement}
          loading={loading}
          nearValue={`(${DBO_TM.sFormat(props?.filter?.end_time)})`}
        ></PostMetrics>
        <CommentsMetrics
          commentsEngagement={commentsEngagement}
          loading={loading}
          nearValue={nearValue}
        ></CommentsMetrics>
      </Col>
    </Row>
  );
}
